import { Switch } from 'react-router-dom';

import IPManagementContainer from './IPManagementContainer';
import IPManagementFormContainer from './IPManagementFormContainer';

import { isAdmin } from '../../utils';

import Route from '../../routes/SentryRoute';

const IPManagementRouter = () => {
  if (!isAdmin()) return null;
  return (
    <Switch>
      <Route exact path="/ip-management" component={IPManagementContainer} />
      <Route
        path="/ip-management/create"
        component={IPManagementFormContainer}
      />
    </Switch>
  );
};

export default IPManagementRouter;
